import React, { useEffect } from 'react'

// Function to detect device type
const detectDevice = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Check for iOS devices (iPhone, iPad, iPod)
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return 'ios';
    }

    // Check for Android devices
    if (/android/i.test(userAgent)) {
        return 'android';
    }

    // Check for desktop devices (Windows, macOS, Linux)
    // If it's not iOS or Android, and has common desktop indicators
    if (
        /Windows|Macintosh|Mac OS X|Linux/.test(userAgent) ||
        (!/Mobile|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent))
    ) {
        return 'desktop';
    }

    // Default to desktop for other devices
    return 'desktop';
};

// Function to get redirect URL based on device
const getAppStoreUrl = (device) => {
    if (device === 'ios') {
        // Apple App Store URL
        return 'https://apps.apple.com/in/app/propacity-plus/id6503435359';
    } else if (device === 'android') {
        // Google Play Store URL
        return 'https://play.google.com/store/apps/details?id=com.dev_propacity.propacity_broker';
    } else {
        // Desktop URL
        return 'https://plus.propacity.in';
    }
};

const UniversalAppLinks = () => {

    useEffect(() => {

        const device = detectDevice();
        const storeUrl = getAppStoreUrl(device);
        window.open(storeUrl, '_self');

    }, []);

    return (
        <div></div>
    )
}

export default UniversalAppLinks